import { Flow } from 'signup-constants/Flow';
import { getFlowKey } from '../routing/getFlowKey';
import { ValidationStatus } from 'signup-ui-lego-core/types';
import { getPrefilledDataKeys, shouldSkipPrefilledSteps } from '../flow-settings/settingsSelectors';
import { getStepData } from '../step/getStepData';
import { getSignupDataValidation } from '../store/signup-data/selectors';
import { hasIntersection } from '../utils/data-structure-utils/hasIntersection';
import { Step } from '../views/Step';
const NonSkippableStepsByFlow = new Map([[Flow.Integrations, [Step.LandingPage]]]);
export const filterPrefilledSteps = (flow, state) => {
  const flowKey = getFlowKey();
  const prefills = getPrefilledDataKeys();
  return flow.filter(stepKey => {
    const stepData = getStepData(stepKey);
    const allStepDataArePrefilled = stepData.every(dataKey => prefills.indexOf(dataKey) > -1);
    const nonSkippableSteps = NonSkippableStepsByFlow.get(flowKey);
    const doesStepDataContainPrefills = hasIntersection(prefills, stepData);

    if (doesStepDataContainPrefills) {
      const isEveryStepDataValid = stepData.every(dataKey => {
        const validation = getSignupDataValidation(state, dataKey);
        return validation && validation === ValidationStatus.VALID;
      });

      if (!isEveryStepDataValid) {
        return true;
      }
    }

    const shouldFilterStep = stepData.length === 0 || !allStepDataArePrefilled || nonSkippableSteps && nonSkippableSteps.includes(stepKey);
    return shouldFilterStep;
  });
};
export const skipPrefilled = (flow, state) => {
  return shouldSkipPrefilledSteps() ? filterPrefilledSteps(flow, state) : flow;
};